module.exports = __webpack_public_path__ + "img/exit_full_screen.257aa065.svg";